/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../../../images/avatar/profile_avatar.png";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import swal from "sweetalert";
import profile from "../../../images/profile/pic1.jpg";
import config from "../../../config";
import formatError from "../../../services/FormatError";
import { useTranslation } from "react-i18next";

import { Icon } from "@iconify/react/dist/iconify.js";
import {
  loadingToggleAction,
  loginConfirmedAction,
} from "../../../store/actions/AuthActions";
import LogoutPage from "./Logout";
import {
  loginProfile,
  runLogoutTimer,
  saveTokenInStorage,
} from "../../../services/AuthService";
import LanguageSelector from "../../components/UIComponents/LanguageSelector";
import { getUnseenChatCount } from "../../../services/ChatService";

const Header = ({
  onOpenNotification,
  notificationCount,
  onOpenChat,
  unseenMessageCount,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const navigate = useNavigate();
  const activeRoute = window.location.pathname.split("/")[1];

  const ctxObj = JSON.parse(sessionStorage.getItem("userDetails"))?.result;
  const state = useSelector((state) => state.auth.auth.result);
  // Unseen message count is now provided by parent to avoid local polling

  const onLoginProfile = (url, text) => {
    loginProfile(url)
      .then((res) => {
        navigate("/business");
        saveTokenInStorage(res.data);
        runLogoutTimer(dispatch, 60 * 60 * 1000, navigate);
        dispatch(loginConfirmedAction(res.data));
        dispatch(loadingToggleAction(true));
        dispatch(loadingToggleAction(false));
        swal("Success", `Logged in as a ${text} successfully`, "success");
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left"></div>

            <ul className="navbar-nav header-right main-notification">
              {/* Admin and superadmin Access */}
              {/* (ctxObj?.role?.id === 1 || ctxObj?.role?.id === 2 || (ctxObj.hasOwnProperty('loggedinprofiletype') && ctxObj.loggedinprofiletype !== "")) */}
              <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown"
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link bell bell-link i-false c-pointer"
                >
                  <a
                    href={`https://calendly.com/wranilus-2hq/30min?month=2025-07`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12,19a1,1,0,1,0-1-1A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-1-1A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-1-1A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-1-1A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,0,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6A3,3,0,0,0,19,3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,0,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-1-1A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-1-1A1,1,0,0,0,7,19Z"></path>
                    </svg>
                  </a>
                </Dropdown.Toggle>
              </Dropdown>
              {ctxObj.hasOwnProperty("loggedinprofiletype") &&
                ctxObj.loggedinprofiletype !== "" && (
                  <Dropdown
                    as="li"
                    className="nav-item dropdown notification_dropdown"
                  >
                    <Dropdown.Toggle
                      variant=""
                      as="a"
                      className="nav-link bell bell-link i-false c-pointer"
                      onClick={() => onOpenNotification()}
                    >
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M22.75 15.8385V13.0463C22.7471 10.8855 21.9385 8.80353 20.4821 7.20735C19.0258 5.61116 17.0264 4.61555 14.875 4.41516V2.625C14.875 2.39294 14.7828 2.17038 14.6187 2.00628C14.4546 1.84219 14.2321 1.75 14 1.75C13.7679 1.75 13.5454 1.84219 13.3813 2.00628C13.2172 2.17038 13.125 2.39294 13.125 2.625V4.41534C10.9736 4.61572 8.97429 5.61131 7.51794 7.20746C6.06159 8.80361 5.25291 10.8855 5.25 13.0463V15.8383C4.26257 16.0412 3.37529 16.5784 2.73774 17.3593C2.10019 18.1401 1.75134 19.1169 1.75 20.125C1.75076 20.821 2.02757 21.4882 2.51969 21.9803C3.01181 22.4724 3.67904 22.7492 4.375 22.75H9.71346C9.91521 23.738 10.452 24.6259 11.2331 25.2636C12.0142 25.9013 12.9916 26.2497 14 26.2497C15.0084 26.2497 15.9858 25.9013 16.7669 25.2636C17.548 24.6259 18.0848 23.738 18.2865 22.75H23.625C24.321 22.7492 24.9882 22.4724 25.4803 21.9803C25.9724 21.4882 26.2492 20.821 26.25 20.125C26.2486 19.117 25.8998 18.1402 25.2622 17.3594C24.6247 16.5786 23.7374 16.0414 22.75 15.8385ZM7 13.0463C7.00232 11.2113 7.73226 9.45223 9.02974 8.15474C10.3272 6.85726 12.0863 6.12732 13.9212 6.125H14.0788C15.9137 6.12732 17.6728 6.85726 18.9703 8.15474C20.2677 9.45223 20.9977 11.2113 21 13.0463V15.75H7V13.0463ZM14 24.5C13.4589 24.4983 12.9316 24.3292 12.4905 24.0159C12.0493 23.7026 11.716 23.2604 11.5363 22.75H16.4637C16.284 23.2604 15.9507 23.7026 15.5095 24.0159C15.0684 24.3292 14.5411 24.4983 14 24.5ZM23.625 21H4.375C4.14298 20.9999 3.9205 20.9076 3.75644 20.7436C3.59237 20.5795 3.50014 20.357 3.5 20.125C3.50076 19.429 3.77757 18.7618 4.26969 18.2697C4.76181 17.7776 5.42904 17.5008 6.125 17.5H21.875C22.571 17.5008 23.2382 17.7776 23.7303 18.2697C24.2224 18.7618 24.4992 19.429 24.5 20.125C24.4999 20.357 24.4076 20.5795 24.2436 20.7436C24.0795 20.9076 23.857 20.9999 23.625 21Z"
                          fill="#EB8153"
                        />
                      </svg>
                      <span className="badge light text-white bg-primary rounded-circle">
                        {notificationCount}
                      </span>
                    </Dropdown.Toggle>
                  </Dropdown>
                )}

              {/* {ctxObj.hasOwnProperty("loggedinprofiletype") && ctxObj.loggedinprofiletype !== "" && (
								<Dropdown as="li" className="nav-item dropdown notification_dropdown me-4">
									<Dropdown.Toggle
										variant=""
										as="a"
										className="nav-link bell bell-link i-false c-pointer"
										onClick={() => onOpenChat()}
									>
										<svg
											width="28"
											height="28"
											viewBox="0 0 28 28"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M22.4605 3.84888H5.31688C4.64748 3.84961 4.00571 4.11586 3.53237 4.58919C3.05903 5.06253 2.79279 5.7043 2.79205 6.3737V18.1562C2.79279 18.8256 3.05903 19.4674 3.53237 19.9407C4.00571 20.4141 4.64748 20.6803 5.31688 20.6811C5.54005 20.6812 5.75404 20.7699 5.91184 20.9277C6.06964 21.0855 6.15836 21.2995 6.15849 21.5227V23.3168C6.15849 23.6215 6.24118 23.9204 6.39774 24.1818C6.5543 24.4431 6.77886 24.6571 7.04747 24.8009C7.31608 24.9446 7.61867 25.0128 7.92298 24.9981C8.22729 24.9834 8.52189 24.8863 8.77539 24.7173L14.6173 20.8224C14.7554 20.7299 14.918 20.6807 15.0842 20.6811H19.187C19.7383 20.68 20.2743 20.4994 20.7137 20.1664C21.1531 19.8335 21.4721 19.3664 21.6222 18.8359L24.8966 7.05011C24.9999 6.67481 25.0152 6.28074 24.9414 5.89856C24.8675 5.51637 24.7064 5.15639 24.4707 4.84663C24.235 4.53687 23.931 4.28568 23.5823 4.11263C23.2336 3.93957 22.8497 3.84931 22.4605 3.84888ZM23.2733 6.60304L20.0006 18.3847C19.95 18.5614 19.8432 18.7168 19.6964 18.8275C19.5496 18.9381 19.3708 18.9979 19.187 18.9978H15.0842C14.5856 18.9972 14.0981 19.1448 13.6837 19.4219L7.84171 23.3168V21.5227C7.84097 20.8533 7.57473 20.2115 7.10139 19.7382C6.62805 19.2648 5.98628 18.9986 5.31688 18.9978C5.09371 18.9977 4.87972 18.909 4.72192 18.7512C4.56412 18.5934 4.4754 18.3794 4.47527 18.1562V6.3737C4.4754 6.15054 4.56412 5.93655 4.72192 5.77874C4.87972 5.62094 5.09371 5.53223 5.31688 5.5321H22.4605C22.5905 5.53243 22.7188 5.56277 22.8353 5.62076C22.9517 5.67875 23.0532 5.76283 23.1318 5.86646C23.2105 5.97008 23.2642 6.09045 23.2887 6.21821C23.3132 6.34597 23.308 6.47766 23.2733 6.60304Z"
												fill="#EB8153"
											/>
											<path
												d="M7.84173 11.4233H12.0498C12.273 11.4233 12.4871 11.3347 12.6449 11.1768C12.8027 11.019 12.8914 10.8049 12.8914 10.5817C12.8914 10.3585 12.8027 10.1444 12.6449 9.98661C12.4871 9.82878 12.273 9.74011 12.0498 9.74011H7.84173C7.61852 9.74011 7.40446 9.82878 7.24662 9.98661C7.08879 10.1444 7.00012 10.3585 7.00012 10.5817C7.00012 10.8049 7.08879 11.019 7.24662 11.1768C7.40446 11.3347 7.61852 11.4233 7.84173 11.4233Z"
												fill="#EB8153"
											/>
											<path
												d="M15.4162 13.1066H7.84173C7.61852 13.1066 7.40446 13.1952 7.24662 13.3531C7.08879 13.5109 7.00012 13.725 7.00012 13.9482C7.00012 14.1714 7.08879 14.3855 7.24662 14.5433C7.40446 14.7011 7.61852 14.7898 7.84173 14.7898H15.4162C15.6394 14.7898 15.8535 14.7011 16.0113 14.5433C16.1692 14.3855 16.2578 14.1714 16.2578 13.9482C16.2578 13.725 16.1692 13.5109 16.0113 13.3531C15.8535 13.1952 15.6394 13.1066 15.4162 13.1066Z"
												fill="#EB8153"
											/>
										</svg>
										<span className="badge light text-white bg-primary rounded-circle">6</span>
									</Dropdown.Toggle>
								</Dropdown>
							)} */}

              <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown me-4"
              >
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link bell bell-link i-false c-pointer"
                  onClick={() => onOpenChat()}
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.4605 3.84888H5.31688C4.64748 3.84961 4.00571 4.11586 3.53237 4.58919C3.05903 5.06253 2.79279 5.7043 2.79205 6.3737V18.1562C2.79279 18.8256 3.05903 19.4674 3.53237 19.9407C4.00571 20.4141 4.64748 20.6803 5.31688 20.6811C5.54005 20.6812 5.75404 20.7699 5.91184 20.9277C6.06964 21.0855 6.15836 21.2995 6.15849 21.5227V23.3168C6.15849 23.6215 6.24118 23.9204 6.39774 24.1818C6.5543 24.4431 6.77886 24.6571 7.04747 24.8009C7.31608 24.9446 7.61867 25.0128 7.92298 24.9981C8.22729 24.9834 8.52189 24.8863 8.77539 24.7173L14.6173 20.8224C14.7554 20.7299 14.918 20.6807 15.0842 20.6811H19.187C19.7383 20.68 20.2743 20.4994 20.7137 20.1664C21.1531 19.8335 21.4721 19.3664 21.6222 18.8359L24.8966 7.05011C24.9999 6.67481 25.0152 6.28074 24.9414 5.89856C24.8675 5.51637 24.7064 5.15639 24.4707 4.84663C24.235 4.53687 23.931 4.28568 23.5823 4.11263C23.2336 3.93957 22.8497 3.84931 22.4605 3.84888ZM23.2733 6.60304L20.0006 18.3847C19.95 18.5614 19.8432 18.7168 19.6964 18.8275C19.5496 18.9381 19.3708 18.9979 19.187 18.9978H15.0842C14.5856 18.9972 14.0981 19.1448 13.6837 19.4219L7.84171 23.3168V21.5227C7.84097 20.8533 7.57473 20.2115 7.10139 19.7382C6.62805 19.2648 5.98628 18.9986 5.31688 18.9978C5.09371 18.9977 4.87972 18.909 4.72192 18.7512C4.56412 18.5934 4.4754 18.3794 4.47527 18.1562V6.3737C4.4754 6.15054 4.56412 5.93655 4.72192 5.77874C4.87972 5.62094 5.09371 5.53223 5.31688 5.5321H22.4605C22.5905 5.53243 22.7188 5.56277 22.8353 5.62076C22.9517 5.67875 23.0532 5.76283 23.1318 5.86646C23.2105 5.97008 23.2642 6.09045 23.2887 6.21821C23.3132 6.34597 23.308 6.47766 23.2733 6.60304Z"
                      fill="#EB8153"
                    />
                    <path
                      d="M7.84173 11.4233H12.0498C12.273 11.4233 12.4871 11.3347 12.6449 11.1768C12.8027 11.019 12.8914 10.8049 12.8914 10.5817C12.8914 10.3585 12.8027 10.1444 12.6449 9.98661C12.4871 9.82878 12.273 9.74011 12.0498 9.74011H7.84173C7.61852 9.74011 7.40446 9.82878 7.24662 9.98661C7.08879 10.1444 7.00012 10.3585 7.00012 10.5817C7.00012 10.8049 7.08879 11.019 7.24662 11.1768C7.40446 11.3347 7.61852 11.4233 7.84173 11.4233Z"
                      fill="#EB8153"
                    />
                    <path
                      d="M15.4162 13.1066H7.84173C7.61852 13.1066 7.40446 13.1952 7.24662 13.3531C7.08879 13.5109 7.00012 13.725 7.00012 13.9482C7.00012 14.1714 7.08879 14.3855 7.24662 14.5433C7.40446 14.7011 7.61852 14.7898 7.84173 14.7898H15.4162C15.6394 14.7898 15.8535 14.7011 16.0113 14.5433C16.1692 14.3855 16.2578 14.1714 16.2578 13.9482C16.2578 13.725 16.1692 13.5109 16.0113 13.3531C15.8535 13.1952 15.6394 13.1066 15.4162 13.1066Z"
                      fill="#EB8153"
                    />
                  </svg>
                  <span className="badge light text-white bg-primary rounded-circle">
                    {unseenMessageCount}
                  </span>
                </Dropdown.Toggle>
              </Dropdown>

              <div className="mt-3">
                <LanguageSelector />
              </div>

              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="nav-link i-false c-pointer"
                  role="button"
                  data-toggle="dropdown"
                >
                  <img
                    src={
                      ctxObj?.user?.PhotoKey
                        ? `${config.appUrl}file/view?key=${ctxObj?.user?.PhotoKey}&type=IMAGE`
                        : avatar
                    }
                    alt="avatar"
                    style={{ objectFit: "cover" }}
                    width={20}
                    height={20}
                  />
                  <div className="header-info">
                    <span>{ctxObj?.user?.username}</span>
                    <small>
                      (
                      {ctxObj?.loggedinprofiletype !== "buyerprofile" &&
                        ctxObj?.loggedinprofiletype !== "sellerprofile" &&
                        ctxObj?.role?.name}
                      {ctxObj?.loggedinprofiletype === "buyerprofile" &&
                        t("endBuyer")}
                      {ctxObj?.loggedinprofiletype === "sellerprofile" &&
                        t("hseller")}
                      )
                    </small>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu align="right" className="mt-2">
                  <Link
                    to="/profile"
                    className="d-flex justify-content-between align-items-center dropdown-item ai-icon"
                  >
                    <div>
                      <svg
                        id="icon-user1"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-primary"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx={12} cy={7} r={4} />
                      </svg>
                      <span
                        style={
                          activeRoute === "profile" ? { color: "#eb8153" } : {}
                        }
                        className="ms-2"
                      >
                        My Profile
                      </span>
                    </div>
                  </Link>
                  {ctxObj?.role?.id === 3 && (
                    <>
                      {ctxObj?.user?.buyerprofile?.id !== 0 ? (
                        <Link
                          to="#"
                          className="d-flex justify-content-between align-items-center dropdown-item ai-icon"
                          onClick={() =>
                            onLoginProfile(
                              config.routes.buyerProfileLogin,
                              "buyer"
                            )
                          }
                        >
                          <div>
                            <svg
                              id="icon-user1"
                              xmlns="http://www.w3.org/2000/svg"
                              className="text-primary"
                              width={18}
                              height={18}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                              <circle cx={12} cy={7} r={4} />
                            </svg>
                            <span
                              style={
                                ctxObj?.loggedinprofiletype === "buyerprofile"
                                  ? { color: "#eb8153" }
                                  : {}
                              }
                              className="ms-2"
                            >
                              {t("sidebarItemBuyerProfile")}
                            </span>
                          </div>
                          {ctxObj?.loggedinprofiletype === "buyerprofile" && (
                            <i
                              style={{ color: "#eb8153" }}
                              className="fa fa-check"
                            ></i>
                          )}
                        </Link>
                      ) : (
                        <Link
                          to={`/buyer`}
                          state={true}
                          className="dropdown-item ai-icon"
                        >
                          <i
                            style={{ color: "#eb8153" }}
                            className="fa fa-user-plus"
                          ></i>
                          <span className="ms-2">
                            {t("buyerProfileCreateButton")}
                          </span>
                        </Link>
                      )}

                      {ctxObj?.user?.sellerprofile?.id !== 0 ? (
                        <Link
                          to="#"
                          className="d-flex justify-content-between align-items-center dropdown-item ai-icon"
                          onClick={() =>
                            onLoginProfile(
                              config.routes.sellerProfileLogin,
                              "seller"
                            )
                          }
                        >
                          <div>
                            <svg
                              id="icon-user1"
                              xmlns="http://www.w3.org/2000/svg"
                              className="text-primary"
                              width={18}
                              height={18}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                              <circle cx={12} cy={7} r={4} />
                            </svg>
                            <span
                              style={
                                ctxObj?.loggedinprofiletype === "sellerprofile"
                                  ? { color: "#eb8153" }
                                  : {}
                              }
                              className="ms-2"
                            >
                              {t("sidebarItemSellerProfile")}
                            </span>
                          </div>
                          {ctxObj?.loggedinprofiletype === "sellerprofile" && (
                            <i
                              style={{ color: "#eb8153" }}
                              className="fa fa-check"
                            ></i>
                          )}
                        </Link>
                      ) : (
                        <Link
                          to={`/seller`}
                          state={true}
                          className="dropdown-item ai-icon"
                        >
                          <i
                            style={{ color: "#eb8153" }}
                            className="fa fa-user-plus"
                          ></i>
                          <span className="ms-2">
                            {t("sellerProfileCreateButton")}
                          </span>
                        </Link>
                      )}

                      {/* {ctxObj?.user?.professional?.id !== 0 ? (
												<Link
													to="#"
													className="d-flex justify-content-between align-items-center dropdown-item ai-icon"
													onClick={() =>
														onLoginProfile(
															config.routes.professionalProfileLogin,
															"professional"
														)
													}
												>
													<div>
														<svg
															id="icon-user1"
															xmlns="http://www.w3.org/2000/svg"
															className="text-primary"
															width={18}
															height={18}
															viewBox="0 0 24 24"
															fill="none"
															stroke="currentColor"
															strokeWidth={2}
															strokeLinecap="round"
															strokeLinejoin="round"
														>
															<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
															<circle cx={12} cy={7} r={4} />
														</svg>
														<span
															style={
																ctxObj?.loggedinprofiletype === "professionalprofile"
																	? { color: "#eb8153" }
																	: {}
															}
															className={`ms-2 ${
																ctxObj?.loggedinprofiletype === "professionalprofile"
																	? "me-2"
																	: ""
															}`}
														>
															Professional Profile
														</span>
													</div>
													{ctxObj?.loggedinprofiletype === "professionalprofile" && (
														<i style={{ color: "#eb8153" }} className="fa fa-check"></i>
													)}
												</Link>
											) : (
												<Link
													to={`/professional`}
													state={true}
													className="dropdown-item ai-icon"
												>
													<i style={{ color: "#eb8153" }} className="fa fa-user-plus"></i>
													<span className="ms-2">Create Professional Profile</span>
												</Link>
											)} */}
                    </>
                  )}

                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
